import { useState } from 'react';
import Logo from '../Logo/Logo';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import './navbar.scss'

const Navbar = () => {
    const [showNavBar, setShowNavBar] = useState(false);

    const toggleShowNavBar = () => setShowNavBar(!showNavBar);

    return (
      <div className="nav">
        <div className="nav__logo">
            <Logo />
        </div>
        <ul
          className={
            "nav__link " + (showNavBar ? "nav__link-show" : "nav__link-hide")
          }
        >
          <li className="nav__link--item">
            <a href="/#home">Home</a>
          </li>
          <li className="nav__link--item">
            <a href="/#aboutus">About Us</a>
          </li>
          <li className="nav__link--item">
            <a href="/#live">Live</a>
          </li>
          <li className="nav__link--item">
            <a href="/#events">Events</a>
          </li>
          <li className="nav__link--item">
            <a href="/#store">Store</a>
          </li>
          <li className="nav__link--item">
            <a href="/#blog">Blog</a>
          </li>
          <li className="nav__link--item">
            <a href="/#communities">Communities</a>
          </li>
          <li className="nav__link--item">
            <button className="nav__button--btn">Give</button>
          </li>
        </ul>

        <div className="nav__button">

            <div className="nav__button--bt">
                <button className="nav__button--btn">Give</button>
            </div>
          <div className="nav__hamburger" onClick={toggleShowNavBar}>
              {!showNavBar ?
                  <MenuIcon fontSize={"large"} /> :
                  <CloseIcon fontSize={"large"} />
              }
          </div>
        </div>

      </div>
    );
  };

export default Navbar
